import React from "react";
import { Card, Row, Col, Button } from "antd";
import "./NotesDetailCard.less";

const NotesDetailCard = ({
  lectureName,
  lectureNumber,
  date,
  coachingLogo,
  onClick,
  classUrl,
}) => {
  return (
    <Card className='coaching-card' onClick={onClick}>
      <Row gutter={[16, 16]}>
        <Col span={6} className='logo-col'>
          <img src={coachingLogo} alt='logo' className='coaching-logo' />
        </Col>
        <Col span={18}>
          <Row className='info-row' gutter={[16, 16]}>
            <Col span={12}>
              <div className='info-label'>Lecture name</div>
              <div className='info-value'>{lectureName}</div>
            </Col>
            <Col span={12}>
              <div className='info-label'>Lecture No.</div>
              <div className='info-value'>{lectureNumber}</div>
            </Col>
          </Row>
          <Row className='info-row' gutter={[16, 16]}>
            <Col span={12}>
              <div className='info-label'>Date</div>
              <div className='info-value'>{date}</div>
            </Col>
            <Col span={8} className='view-button-container'>
              <Button
                type='primary'
                className='view-button'
                onClick={() => window.open(classUrl, "_blank")}
              >
                View
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default NotesDetailCard;
